import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { useContext, useRef, useEffect } from 'react';
import { Icon } from '../../icon/index.js';
import Button from '../Button/button.js';
import '../Button/index.js';
import { IconStyled } from './style.js';
import { DropdownMenuContext } from './DropdownMenuContext.js';

var DropdownButtonButton = function DropdownButtonButton(_a) {
  var fcStyle = _a.fcStyle,
      label = _a.label,
      buttonColor = _a.buttonColor,
      primary = _a.primary,
      rest = __rest(_a, ["fcStyle", "label", "buttonColor", "primary"]);

  var _b = useContext(DropdownMenuContext),
      dropdownState = _b.dropdownState,
      dispatch = _b.dispatch;

  var buttonRef = useRef(null);

  var toggleMenu = function toggleMenu() {
    if (dropdownState.menuOpen) {
      dispatch({
        type: 'SET_MENU_OPEN',
        payload: false
      });
      setTimeout(function () {
        dispatch({
          type: 'SET_MENU_VISIBLE',
          payload: false
        });
        dispatch({
          type: 'SET_SELECTED_ITEM_INDEX',
          payload: 0
        });
      }, 200);
    } else {
      dispatch({
        type: 'SET_MENU_VISIBLE',
        payload: true
      });
      dispatch({
        type: 'SET_MENU_OPEN',
        payload: true
      });
    }
  };

  var handleButtonKeyDown = function handleButtonKeyDown(e) {
    switch (e.key) {
      case 'ArrowDown':
        if (!dropdownState.menuOpen) {
          toggleMenu();
          return;
        }

      case 'Enter':
        e.preventDefault();
        toggleMenu();
        return;
    }
  };

  var ariaProps = {};

  if (dropdownState.menuOpen) {
    ariaProps = __assign(__assign({}, ariaProps), {
      'aria-expanded': true,
      'aria-controls': dropdownState.id + "-menu"
    });
  }

  useEffect(function () {
    dispatch({
      type: 'SET_BUTTON_REF',
      payload: buttonRef
    });
  }, [buttonRef]);
  return /*#__PURE__*/React.createElement(Button, __assign({
    id: dropdownState.id,
    tabIndex: 0,
    "aria-haspopup": true
  }, ariaProps, {
    ref: buttonRef,
    fcStyle: fcStyle,
    primary: primary,
    onClick: function onClick() {
      return toggleMenu();
    },
    as: dropdownState.as,
    buttonColor: buttonColor,
    onKeyDown: function onKeyDown(e) {
      return handleButtonKeyDown(e);
    }
  }, rest), label, /*#__PURE__*/React.createElement(IconStyled, {
    renderAs: dropdownState.as
  }, /*#__PURE__*/React.createElement(Icon, {
    title: dropdownState.menuOpen ? 'Menu open' : 'Menu closed',
    icon: dropdownState.menuOpen ? 'caret-up' : 'caret-down'
  })));
};

export default DropdownButtonButton;